import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../../../../../../lib/store';
import { getIndividualUserName } from '../../../../../../../lib/store/crm';

import { useIsMobile } from '../../../../../../../hooks';
import AppVersion from '../../../../../../AppVersion/AppVersion';
import { Preloader } from '../../../../../../index';
import PersonalContactDetails from '../personalContactDetails/PersonalContactDetails';
import PersonalNameDetails from '../personalNameDetails/PersonalNameDetails';

import styles from './PersonalDetailsComponent.module.scss';

const PersonalDetailsComponent = (props: ReduxProps) => {
  const { individual, individualUserName, getUserName } = props;
  const isMobile = useIsMobile();

  useEffect(() => {
    getUserName();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!individual || !individualUserName) {
    return <div className={styles.loader}><Preloader owner="Personal Details" text="" /></div>;
  }

  const { first_name, middle_name, last_name, email, phone_number, addresses } = individual;

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperPersonalDetails}>
        <PersonalNameDetails
          firstName={first_name}
          middleName={middle_name || ''}
          lastName={last_name}
          username={individualUserName}
        />
        <PersonalContactDetails email={email} phoneNumber={phone_number || ''} />
      </div>
      {!isMobile && <AppVersion />}
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  getUserName: (): void => dispatch(getIndividualUserName()),
});

const mapStateToProps = (state: RootState) => ({
  individual: state.crm.individualExtendedInfo,
  individualUserName: state.crm.individualUserName,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(PersonalDetailsComponent);
